import React from "react";
import { FaUserCircle } from "react-icons/fa";
import NameLogo from "../utils/NameLogo";

function ChatMessage({ name, message }) {
  return (
    <div className="px-4 py-2 my-1.5 flex gap-3 items-start shadow-lg bg-gray-300 w-[98%] rounded-md">
      <div className="flex items-center gap-3">
        <NameLogo name={name} />
        <span className="font-bold">{name}</span>
      </div>
      <span className="pt-1">{message}</span>
    </div>
  );
}

export default ChatMessage;
